import React from 'react';
import { Button } from '@mui/material';

interface ContactMethodButtonProps {
    value: string;
    onChange: (method: string) => void;
}

const methods = ['Text', 'Email', 'Call'];

const ContactMethodButton: React.FC<ContactMethodButtonProps> = ({
    value,
    onChange,
}) => {
    return (
        <div style={{ display: 'flex', gap: '1rem' }}>
            {methods.map((method) => (
                <Button
                    key={method}
                    variant={value === method ? 'contained' : 'outlined'}
                    color={value === method ? 'secondary' : 'inherit'}
                    onClick={() => onChange(method)}
                    style={{
                        flex: 1,
                        fontWeight: 500,
                        borderRadius: '0.75rem',
                        border: `1px solid #D1D2D9`,
                        fontSize: '1rem',
                        lineHeight: '1.5',
                        fontFamily: 'inherit',
                        padding: '0.75rem',
                        textTransform: 'none',
                        color: value === method ? 'white' : 'black',
                    }}
                    type="button"
                >
                    {method}
                </Button>
            ))}
        </div>
    );
};

export default ContactMethodButton;
